import { useMemo } from 'react';

import SortAndFilterConfig, { FilterMethods } from '../../../../../modules/sortAndFilter/config/SortAndFilterConfig';

/**
 * Loops through the given config filters, removes those that are not enabled and sorts them by order.
 */
const useFormatFilterUi = (config: SortAndFilterConfig) => {
    const filteredOptions = useMemo(() => {
        const filterKeys = Object.keys(config.filters) as FilterMethods[];

        return filterKeys
            .filter((key) => config.filters[key]?.enabled)
            .sort((a, b) => {
                const aValue = config.filters[a]?.order || 0;
                const bValue = config.filters[b]?.order || 0;

                return aValue - bValue;
            });
    }, [config]);

    return filteredOptions;
};

export default useFormatFilterUi;
